import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackCreateWishListParameters extends TrackEventBaseParameters {}

const trackCreateWishList = (parameters: TrackCreateWishListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "create_wishlist", ...parameters }, options);
};

export default trackCreateWishList;
